import { Link } from "react-router-dom";
import AxiosClient from "../../assets/AxiosClient";
import { useStateContext } from "../../Contexts/ContextProvider";

const NewsRow = ({ id, title, description, artImage, status , setOnDelete }) => {
  const { API } = useStateContext();

  const handleDeleteArt = async () => {
    const confirmed = window.confirm("Are you sure you want to delete this article?");

    if (confirmed) {
      try {
        const response = await AxiosClient.delete(`news/${id}`);
        alert("Article deleted successfully");
        // Optionally, trigger a re-fetch of articles or update state here if needed.
      } catch (error) {
         console.error("Error deleting article:", error);
        alert("Failed to delete article. Please try again.");
      }
    } 
    setOnDelete((prev)=> !prev) ; 
  };

  return (
    <>
      <tr>
        <td className="h1 text-dark">
          <div className="px-2">
            <div></div>
            <div className="">
              <h6 className="mb-0 ">{title}</h6>
            </div>
          </div>
        </td>
        <td></td>

        <td className="align-middle">
          <Link to={`./Edite/${id}`} className="btn btn-info m-2">
            Edit
          </Link>
          <button className="btn btn-danger m-2" onClick={handleDeleteArt}>
            Delete
          </button>
        </td>
      </tr>
    </>
  );
};

export default NewsRow;
